import { render, staticRenderFns } from "./PriceIndexForm.vue?vue&type=template&id=91948132"
import script from "./PriceIndexForm.vue?vue&type=script&lang=js"
export * from "./PriceIndexForm.vue?vue&type=script&lang=js"
import style0 from "./PriceIndexForm.vue?vue&type=style&index=0&id=91948132&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports